module.exports = __webpack_public_path__ + "img/oil_diesel.7597350f.png";